import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { throwIfAlreadyLoaded } from './helpers/module-import.guard';
import { HttpClientModule } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import {
    UserService,
    AccountService,
    ContactService,
    LoginService,
    TradingAccountService,
    TradingGroupService,
    LookupService,
    DepositService,
    CreditCardPaymentDeviceService,
    RequestService,
    WithdrawService,
    SkrillPaymentDeviceService,
    BankAccountPaymentDeviceService,
    RegisterService,
    TransferService,
    NetellerPaymentDeviceService,
    BPayPaymentDeviceService,
    PoliPaymentDeviceService,
    UnionPayCardService,
    FasapayPaymentDeviceService,
    PaymentPlatformService,
    TradeService,
    DocumentService,
    RewardService,
    WatchdogService,
    ApplicationKeyService,
    SymbolService,
    AgentService,
    AgentAdminService,
    GatewayService,
    PlatformService,
    PayoutService,
    FingerprintService,
    AccountAdminService,
    XPayThaiPaymentDeviceService,
    CreditToBalanceService,
    DocumentPerTenantService,
    RefundService,
    ConfigService,
    GoodwillService,
    SwapsService,
    PromotionService,
    ErrorLogService,
    PaymentDeviceService,
    ConvertAccountService,
    CreateBankWireTransferDepositService,
    RepairDepositService,
    SyncDepositService,
    BulkTransferService
} from './api/services';
import { SalesService } from './api/services/sales.service';
import { AvailablePlatformService } from './api/services/available-platform.service';

@NgModule({
    declarations: [],
    imports: [CommonModule, HttpClientModule],
    providers: [
        AccountService,
        AgentService,
        ApplicationKeyService,
        AvailablePlatformService,
        BankAccountPaymentDeviceService,
        BPayPaymentDeviceService,
        ConfigService,
        ContactService,
        CookieService,
        CreditCardPaymentDeviceService,
        CreditToBalanceService,
        DepositService,
        DocumentPerTenantService,
        DocumentService,
        FasapayPaymentDeviceService,
        FingerprintService,
        GatewayService,
        GoodwillService,
        LoginService,
        LookupService,
        NetellerPaymentDeviceService,
        PaymentDeviceService,
        AccountAdminService,
        PaymentPlatformService,
        PayoutService,
        PlatformService,
        PoliPaymentDeviceService,
        PromotionService,
        RefundService,
        RegisterService,
        RequestService,
        RewardService,
        SalesService,
        SkrillPaymentDeviceService,
        SwapsService,
        BulkTransferService,
        SymbolService,
        TradingAccountService,
        TradingGroupService,
        TransferService,
        TradeService,
        UnionPayCardService,
        UserService,
        WatchdogService,
        WithdrawService,
        XPayThaiPaymentDeviceService,
        ErrorLogService,
        AgentAdminService,
        ConvertAccountService,
        CreateBankWireTransferDepositService,
        SyncDepositService,
        RepairDepositService
    ]
})
export class EightcapCoreModule {
    constructor(@Optional() @SkipSelf() parentModule: EightcapCoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
